export default "__VITE_ASSET__isSUGdO$__"